'use client'

import { DropdownMenu, Icon, IconComponent } from '@graftcode/design-system'

import { SELECTOR_TEST_IDS } from '@common/common-test-ids.const'
import { useDelayedSkeletonLoading } from '@common/hooks'

import type { Props } from './Selector.types'

import styles from './Selector.module.scss'

export function Selector({ selectedName, items, loading = false, disabled, onSelect }: Props) {
  const showSkeleton = useDelayedSkeletonLoading(loading)

  return (
    <DropdownMenu
      data-testid={SELECTOR_TEST_IDS.root}
      className={styles.dropdownMenu}
      width="s"
      items={items}
      disabled={loading || disabled}
      searchPlaceholder="Find project..."
      sideOffset={4}
      onItemClick={onSelect}
    >
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <span className={styles.separator}>/</span>

          <div className={styles.item}>
            <IconComponent icon={Icon.FolderRegular} />
            {showSkeleton ? (
              <span className={styles.loadingSkeleton} aria-label="Loading project" role="status" />
            ) : (
              <>
                <span>{selectedName}</span>
                <IconComponent className={styles.selectorIcon} icon={Icon.ChevronUpDownFilled} />
              </>
            )}
          </div>
        </div>
      </div>
    </DropdownMenu>
  )
}
